import type { WorkspaceMembership } from "@goalhorns/shared";

/**
 * The server's memberships, with workspaces this browser opened recently first (most recent first).
 * The rest keep the server's order (by name). Remembered ids that are not memberships are dropped,
 * so a stale id never shows. Returns a new array; the inputs are not mutated.
 */
export function orderMemberships(
  memberships: readonly WorkspaceMembership[],
  recentIds: readonly string[],
): WorkspaceMembership[] {
  const rank = new Map(recentIds.map((id, index) => [id, index]));
  const rankOf = (id: string) => rank.get(id) ?? Number.POSITIVE_INFINITY;
  return memberships
    .map((membership, index) => ({ membership, index }))
    .sort((a, b) => rankOf(a.membership.id) - rankOf(b.membership.id) || a.index - b.index)
    .map(({ membership }) => membership);
}
